import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import { CircularProgress } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { StyledButton } from '../styles/StyledButtons';

interface LoadingStateProps {
  loading: boolean;
  error: string | null;
  onRetry: () => void;
}

export function LoadingState({ loading, error, onRetry }: LoadingStateProps) {
  if (loading) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
        <CircularProgress />
        <Typography>Generating secure login code...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
        <Alert severity="error">{error}</Alert>
        <StyledButton
          variant="contained"
          startIcon={<RefreshIcon />}
          onClick={onRetry}
          noTopSpacing={true}
        >
          Try Again
        </StyledButton>
      </Box>
    );
  }

  return null;
}
